import { Select as BaseSelect } from "@base-ui-components/react/select";
import { CheckIcon } from "lucide-react";
import {
  selectItemClasses,
  selectItemIndicatorClasses,
  selectItemIndicatorIconClasses,
  selectItemTextClasses,
} from "./Option.style";

export type OptionProps = BaseSelect.Item.Props;

const Option = (props: OptionProps) => {
  const { value, children, label, className, ...rest } = props;
  return (
    <BaseSelect.Item
      className={selectItemClasses({
        className: typeof className === "string" ? className : "",
      })}
      value={value}
      label={label}
      {...rest}
    >
      <BaseSelect.ItemText className={selectItemTextClasses()}>
        {label && !children ? label : children}
      </BaseSelect.ItemText>
      <BaseSelect.ItemIndicator className={selectItemIndicatorClasses()}>
        <CheckIcon className={selectItemIndicatorIconClasses()} />
      </BaseSelect.ItemIndicator>
    </BaseSelect.Item>
  );
};

Option.displayName = "Option";

export default Option;
